module.exports = ".brand {\n  -ms-flex-line-pack: rigth;\n      align-content: rigth; }\n\n.align-buttons {\n  text-align: right; }\n\ninput {\n  width: 70px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-estimate-configuration/master-estimate-configuration.component.scss
// module id = ./src/app/master/master-estimate-configuration/master-estimate-configuration.component.scss
// module chunks = main